import React from 'react';

import WorkflowCanvas from '../../components/WorkflowBuilder';
import CommandPalette from '../../components/CommandPalette';

const WorkflowCreate: React.FC = () => {
  return (
    <>
      <WorkflowCanvas
        workflow={{
          graphEdges: {
            edges: [],
            pageInfo: {
              hasNextPage: false,
              hasPreviousPage: false,
            },
            totalCount: 0,
          },
          graphNodes: {
            edges: [],
            pageInfo: {
              hasNextPage: false,
              hasPreviousPage: false,
            },
            totalCount: 0,
          },
        }}
      />
      <CommandPalette />
    </>
  );
};

export default WorkflowCreate;
